import { render } from "./developer-page.vue?vue&type=template&id=ca49688e&scoped=true"
import script from "./developer-page.vue?vue&type=script&lang=js"
export * from "./developer-page.vue?vue&type=script&lang=js"

import "./developer-page.vue?vue&type=style&index=0&id=ca49688e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca49688e"]])

export default __exports__